import script from "./WaitComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitComponent.vue?vue&type=script&setup=true&lang=js"

import "./WaitComponent.vue?vue&type=style&index=0&id=17b707a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b707a0"]])

export default __exports__